import React from "react";
import { withStyles, createStyles, WithStyles, Theme } from "@material-ui/core/styles";

import Grid from "../lib/components/grid";
import { SailingScheduleColumns } from "./sailingloadouttablesetup";

type SailingScheduleGridProps = {
    data?: any[];
    loading?: boolean;
    clearFilters?: string;
    handleRefresh?: () => void;
    rowRenderer?: (props: any) => React.ReactElement;
    totalRowColumns?: string[];
    menuItems?: any;
    vesseloptions?: any[];
    portoptions?: any[];
    shippinglines?: any[];
    GridColumns?: (data: any[], filters: any, arrangement: any, columnsWidth: any) => any[];
    headers?: Record<string, string>;
    gridHeight?: number;
    toolbarChildren?: any;
} & WithStyles<typeof styles>;

const styles = (theme: Theme) =>
    createStyles({
        root: {
            height: "100%",
            width: "100%",
            position: "relative",
        },
    });

class SailingScheduleGridUnstyled extends React.Component<SailingScheduleGridProps> {
    render() {
        const {
            classes,
            loading = false,
            clearFilters,
            handleRefresh,
            rowRenderer,
            totalRowColumns,
            menuItems,
            GridColumns,
            gridHeight,
            toolbarChildren,
        } = this.props;

        return (
            <div className={classes.root}>
                <Grid
                    fill
                    forceHeight={gridHeight}
                    loading={loading}
                    data={this.props.data || []}
                    GridColumns={GridColumns || ((data, filters, columnArrangement, columnsWidth) =>
                        SailingScheduleColumns(
                            data,
                            filters,
                        )
                    )}
                    rowRenderer={rowRenderer}
                    handleRefresh={handleRefresh}
                    clearFilters={clearFilters}
                    totalRowColumns={totalRowColumns}
                    menuItems={menuItems}
                    toolbarChildren={toolbarChildren}
                />
            </div>
        );
    }
}

export default withStyles(styles)(SailingScheduleGridUnstyled);
